export type StudioInstallPlatform = 'android' | 'ios-safari' | 'ios-other' | 'generic';

export function resolveStudioInstallPlatform(
  isIos: boolean,
  isIosSafari: boolean,
  canPromptInstall: boolean
): StudioInstallPlatform {
  if (canPromptInstall && !isIos) return 'android';
  if (isIos && canPromptInstall) return 'android';
  if (isIos) return isIosSafari ? 'ios-safari' : 'ios-other';
  return 'generic';
}
